const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_ZABBIX_TRIGGERS_SUCCESS') {
        return {
            ...state,
            [action.actionParams.id]: action.payload,
        };
    }

    return state;
}

export default reducer;
